var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{directives:[{name:"bg-typography",rawName:"v-bg-typography",value:('h1'),expression:"'h1'"}],style:({ marginTop: '10px' })},[_vm._v("Files")])])
}
var staticRenderFns = []

export { render, staticRenderFns }